import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
export const config = {
    value: 'formReload',
    position: ALL_BUTTON_POSITION_LIST,
    action: (arg) => {
        const { buttonConfig, _context } = arg || {};
        const { options = {} } = buttonConfig;
        const { _bindForm } = options;
        function reloadOneForm(id) {
            if (typeof id === 'string') {
                const form = _context.$(id);
                form?.load?.();
            }
        }
        if (_bindForm && _context) {
            if (Array.isArray(_bindForm)) {
                _bindForm.forEach((item) => {
                    reloadOneForm(item);
                });
            }
            else {
                reloadOneForm(_bindForm);
            }
        }
    },
};
